export const BDD_SKILLS = [
  { nom: "PostgreSQL", image: "/assets/img/icon/stack/postgre.webp" },
  { nom: "MySQL",      image: "/assets/img/icon/stack/mysql.webp" },
  { nom: "SQL Server", image: "/assets/img/icon/stack/sqlserver.svg" },
  { nom: "MongoDB",    image: "/assets/img/icon/stack/mongo.webp" },
  { nom: "SQLite",     image: "/assets/img/icon/stack/sqlite.svg" },
  { nom: "Prisma", image: "/assets/img/icon/stack/prisma.svg" },
];
